import { Platform } from 'react-native';
import styled from 'styled-components/native';

import { Body1, H1 } from '@src/components/Typography';
import { padding, windowHeight } from '@src/configuration/constants';

const isWeb = Platform.OS === 'web';

export const ScrollView = styled.ScrollView.attrs({
  scrollEventThrottle: 30,
  contentContainerStyle: {
    flexGrow: 1,
    paddingVertical: padding * 2,
    paddingHorizontal: padding,
    height: isWeb ? '100%' : undefined,
    maxHeight: isWeb ? windowHeight * 0.9 : undefined,
  },
})`
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Title = styled(H1)<{ level?: number }>`
  text-align: center;
  font-size: ${({ theme, level = 0 }) =>
    theme.typography.heading[1].fontSize + level * 2}px;
  line-height: ${({ theme, level = 0 }) =>
    theme.typography.heading[1].lineHeight + level * 2}px;
`;

export const Content = styled(Body1)<{ level?: number }>`
  font-size: ${({ theme, level = 0 }) =>
    theme.typography.body[1].fontSize + level * 2}px;
  line-height: ${({ theme, level = 0 }) =>
    theme.typography.body[1].lineHeight + level * 2}px;
`;
